import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import TablePage from "../../../components/Pages/TablePage/TablePage";
import {useSocket} from "../../../hooks/useSocket";
import StatusCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/StautsCell/StatusCell";
import {useAPI} from "../../../hooks/useAPI";
import NotificationsModal from "./Modal/NotificationsModal";
import Modal from "../../../components/Modal";
import {General_API} from "../General_API";
import {formatDate} from "../../../utils/utils";
import {AuthContext} from "../../../context/AuthContext";

function ManagerNotifications(props) {
    const {APIRequest} = useAPI();
const userId = useContext(AuthContext)?.token?.userId
    //Работа с сокетами

    const {sendMessage} = useSocket(
        process.env.REACT_APP_SOCKET_HOST,
        onMessage,
        onConnect
    );

    function onConnect(socket) {
        socket.emit("join", "systemManager");
    }

    function onMessage(socket) {
        socket.on("newRequestAdded", (newRequest) => {
            getData();
        });
        socket.on("changeStatus", () => {
            getData();
        });
    }

    //Модальное окно

    const [modal, setModal] = useState([]);
    const [image, setImage] = useState("");

    const addModal = async (id, status, userId) => {
        await APIRequest({api: `/api/v2/systemManagers/${userId}/notifications/${id}`, method: "GET"})
            .then(res =>
                setModal((prev) => {
                    changeStatus(id, userId);
                    return [{status, userId, ...res?.body?.data[0]}, ...prev];
                })
            );
    };

    const deleteModal = () => {
        setModal((prev) => {
            const newArr = [...prev];
            newArr.splice(0, 1);
            return newArr;
        });
    };

    const agree = async (id, userId) => {
        await APIRequest(General_API.notifications.accept(userId,id));
        sendMessage("changeStatus", "systemManager");
        sendMessage("changeStatus", userId);
        await getData();
        setModal([]);
    };

    const disagree = async (id, userId) => {
        await APIRequest(General_API.notifications.cancel(userId,id));
        sendMessage("changeStatus", "systemManager");
        sendMessage("changeStatus", userId);
        await getData();
        setModal([]);
    };

    const changeStatus = async (id, userId) => {
        await APIRequest(General_API.notifications.changeStatus(id)).then((res) => {
            if (res.message === "ok") {
                sendMessage("changeStatus", userId);
                sendMessage("changeStatus", "systemManager");
                getData();
            }
        });
    };

    // ***

    //Страница
    const [filterOptions, setFilterOptions] = useState("");
    const [data, setData] = useState([]);

    const [pagination, setPagination] = useState({
        limit: 20,
        resultsCount: 0,
        offset: 1,
        allPages: 2,
    });

    function offsetHandler(offset) {
        setPagination({...pagination, offset: offset});
    }

    function limitHandler(limit) {
        setPagination({...pagination, limit});

    }

    const filterHandler = (e) => {
        setFilterOptions(e);
        offsetHandler(1);
    };

    const changeDataStatus = (id, value) => {
        data.forEach((item) => {
            if (item._id === id)
                setData((prev) => [...prev, {...item, status: value}]);
        });
    };
    //Получение данных

    const getData = async () => {
        await APIRequest(General_API.notifications.getAllNotifications(userId,pagination.limit, pagination.offset)).then(
            (res) => {

                if (res.message === "Заказы успешно получены.") {
                    setData(res?.body?.data);
                    setPagination({...pagination, resultsCount: res.body?.pagination?.resultsCount})
                }
            }
        );
    };

    useEffect(() => {
        getData();
    }, [pagination.limit, pagination.offset]);

    //Осталаьное
    const statusColorSwitcher = (status) => {
        if (status === "В ожидании") return "blue";
        if (status === "Отклонено") return "red";
        if (status === "В работе") return "orange";
        if (status === "Одобрено") return "green";
        if (status) return "green";
    };

    // @ts-ignore
    return (
        <>
            <NotificationsModal
                data={modal}
                setImage={setImage}
                agree={agree}
                disagree={disagree}
                addModal={addModal}
                deleteModal={deleteModal}
                isOpen={true}
            />

            {
                // @ts-ignore
                image ? (
                    <>
                        <Modal onOutsideClick={(_) => setImage("")}>
                            <StyledImage imageLink={image}/>
                        </Modal>
                    </>
                ) : (
                    " "
                )
            }

            <TablePage
                pageName={"TablePage"}
                loading={false}
                tableFirstRow={[
                    {title: " ", style: {display: "none"}},
                    {title: "#"},
                    {title: "ФИО"},
                    {title: "Роль", style: {div: {justifyContent: "center"}}},
                    {title: "Дата"},
                    {title: "Статус"},
                ]}
                tableHaveToShow={[
                    {type: "wrapperCell", typeData: {cell: (props) => " "}},
                    {
                        type: "wrapperCell",
                        onClick: (props) =>
                            addModal(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => <LinkCell3 linkTitle={props.all?.ticket_id}/>,
                        },
                    },
                    {
                        type: "wrapperCell",
                        onClick: (props) =>
                            addModal(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => <LinkCell3 linkTitle={props.all?.info[0]?.fio}/>,
                        },
                    },
                    {
                        type: "wrapperCell",
                        onClick: (props) =>
                            addModal(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => <LinkCell3 linkTitle={props.all.role}/>,
                        },
                    },
                    {
                        type: "wrapperCell",
                        onClick: (props) =>
                            addModal(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => (
                                <LinkCell3 linkTitle={formatDate(props?.all?.created_at)}/>
                            ),
                        },
                    },
                    {
                        type: "wrapperCell",
                        onClick: (props) =>
                            addModal(props?.id, props?.status, props.user_id),
                        typeData: {
                            cell: (props) => (
                                <StatusCell
                                    color={statusColorSwitcher(props?.all?.status)}
                                    text={props?.all?.status}
                                />
                            ),
                        },
                    },
                ]}
                tableStorage={data}
                tableTitle={""}
                sortHandler={() => {
                }}
                filterChangeURL={(e) => filterHandler(e)}
                showCountChanger={limitHandler}
                setActualPage={offsetHandler}
                breadCrumbsItems={[
                    {title: "Главная"},
                    {title: "Уведомелния", actual: true},
                ]}
                filterFieldsConf={{
                    fio: true,
                    period: true,
                    date: true,
                }}
                pagination={pagination}
                filterBarButtons={{downloadTemplate: {show: false}}}
                addOrg={{}}
                exportTemplateButtons={{export: false, registry: false}}
            />
        </>
    );
}

const StyledImage = styled.div`
  background-image: url(${(p) => p?.imageLink});
  max-width: 100%;
  max-height: 100%;
  width: 60%;
  height: 60%;
  background-repeat: round;
`;

export default ManagerNotifications;
